const VERSION_KEY = 'app_version';
const CACHE_VERSION_KEY = 'cache_version';

export const versionService = {
  getCurrentVersion: () => {
    return import.meta.env.VITE_APP_VERSION || '1.0.0';
  },

  getBuildTime: () => {
    return import.meta.env.VITE_BUILD_TIME || new Date().toISOString();
  },

  getStoredVersion: () => {
    return localStorage.getItem(VERSION_KEY);
  },

  setStoredVersion: (version) => {
    localStorage.setItem(VERSION_KEY, version);
  },

  getCacheVersion: () => {
    return localStorage.getItem(CACHE_VERSION_KEY);
  },

  setCacheVersion: (version) => {
    localStorage.setItem(CACHE_VERSION_KEY, version);
  },

  isVersionChanged: () => {
    const currentVersion = versionService.getCurrentVersion();
    const storedVersion = versionService.getStoredVersion();
    return currentVersion !== storedVersion;
  },

  clearAppCache: async () => {
    try {
      if ('caches' in window) {
        const cacheNames = await caches.keys();
        await Promise.all(
          cacheNames.map(cacheName => caches.delete(cacheName))
        );
      }

      const keysToKeep = [
        'authData',
        'rememberMeData',
        'organizationDetails',
        'server_url',
      ];

      const allKeys = Object.keys(localStorage);
      allKeys.forEach(key => {
        if (!keysToKeep.includes(key)) {
          localStorage.removeItem(key);
        }
      });

      if ('indexedDB' in window) {
        const databases = ['NGOSurveyorDB', 'sina_db', 'forms_cache', 'submissions_cache'];
        for (const dbName of databases) {
            try {
                await indexedDB.deleteDatabase(dbName);
            } catch (error) {
                console.warn(`Could not delete database ${dbName}:`, error);
            }
        }
      }

      return true;
    } catch (error) {
      console.error('Cache clear failed:', error);
      return false;
    }
  },

  handleVersionUpdate: async () => {
    const currentVersion = versionService.getCurrentVersion();
    const storedVersion = versionService.getStoredVersion();

    if (!storedVersion) {
      versionService.setStoredVersion(currentVersion);
      versionService.setCacheVersion(currentVersion);
      return { isFirstInstall: true, needsUpdate: false };
    }

    if (currentVersion !== storedVersion) {
      const cleared = await versionService.clearAppCache();

      if (cleared) {
        versionService.setStoredVersion(currentVersion);
        versionService.setCacheVersion(currentVersion);

        return {
          isFirstInstall: false,
          needsUpdate: true,
          oldVersion: storedVersion,
          newVersion: currentVersion
        };
      } else {
        return {
          isFirstInstall: false,
          needsUpdate: true,
          clearFailed: true,
          oldVersion: storedVersion,
          newVersion: currentVersion
        };
      }
    }

    return { isFirstInstall: false, needsUpdate: false };
  },

  getVersionInfo: () => {
    return {
      current: versionService.getCurrentVersion(),
      stored: versionService.getStoredVersion(),
      buildTime: versionService.getBuildTime(),
      isChanged: versionService.isVersionChanged()
    };
  }
};